import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import UseSegmentImage from './UseSegmentImage'

const copy = {
  heading: `Use Segment to integrate with internal systems and best-in-class tools`,
  description: `Activate audiences in ${process.env.INTEGRATION_COUNT}+ marketing and analytics tools in real time.`,
}

const UseSegment: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper>
      <SectionBase variant="2Col" reverse={true}>
        <SectionCopy>
          <CopyTextBase>
            <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
            <CopyText.Description variant="pLarge" tag="p">
              {copy.description}
            </CopyText.Description>
          </CopyTextBase>
        </SectionCopy>
        <Section.Contents>
          <UseSegmentImage />
        </Section.Contents>
      </SectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: grid;
  background: ${({ theme }) => theme.palette.twilio.gray[10]};
`

const SectionCopy = styled(Section.Copy)`
  display: flex;
  align-items: center;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 392px;
    justify-self: end;
    align-self: center;
  }
`

export default UseSegment
